import { SimpleSelect } from "@/shared/ui/SimpleSelect";
import { Input, Label } from "@devhop/ui";

type JamRegistrationsFilterProps = {
  status?: string;
  categoryId?: string;
  search?: string;
  categories: Array<{ id: string; name: string }>;
  onStatusChange: (value: string | undefined) => void;
  onCategoryChange: (value: string | undefined) => void;
  onSearchChange: (value: string | undefined) => void;
};

export function JamRegistrationsFilter({
  status,
  categoryId,
  search,
  categories,
  onStatusChange,
  onCategoryChange,
  onSearchChange,
}: JamRegistrationsFilterProps) {
  return (
    <div className="grid gap-4 sm:grid-cols-3">
      <div className="flex flex-col gap-2">
        <Label>ຄົ້ນຫາ</Label>
        <Input
          placeholder="ຊື່ / ເບີ / ຊື່ທີມ"
          value={search ?? ""}
          onChange={(e) => onSearchChange(e.target.value || undefined)}
        />
      </div>
      <div className="flex flex-col gap-2">
        <Label>ສະຖານະ</Label>
        <SimpleSelect
          value={status ?? "all"}
          onValueChange={(v) => onStatusChange(v === "all" ? undefined : v)}
          placeholder="ທັງໝົດ"
          options={[
            { value: "all", label: "ທັງໝົດ" },
            { value: "pending", label: "ລໍຖ້າຕິດຕໍ່" },
            { value: "contacted", label: "ຕິດຕໍ່ແລ້ວ" },
            { value: "confirmed", label: "ຢືນຢັນແລ້ວ" },
            { value: "rejected", label: "ປະຕິເສດ" },
            { value: "converted", label: "ແປງເປັນນັກຮຽນແລ້ວ" },
          ]}
        />
      </div>
      <div className="flex flex-col gap-2">
        <Label>ໝວດໝູ່</Label>
        <SimpleSelect
          value={categoryId ?? "all"}
          onValueChange={(v) => onCategoryChange(v === "all" ? undefined : v)}
          placeholder="ທັງໝົດ"
          options={[
            { value: "all", label: "ທັງໝົດ" },
            ...categories.map((c) => ({ value: c.id, label: c.name })),
          ]}
        />
      </div>
    </div>
  );
}
